var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"sortable",class:[_vm.classes, _vm.propsClass],on:{"click":_vm.setOrderBy}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }